import { resolvePublicLogin, type PublicLoginKind } from '@/api/publicLogin'
import { applyMemberHomeAfterLogin } from '@/composables/useLoginDestination'
import { SELLER_CENTER_PATH } from '@/composables/useSellerCenter'
import type { SellerSession } from '@/constants/sellerSession'

export type { PublicLoginKind }

export type LoginKindDecision = PublicLoginKind | 'choose'

export function preferSellerLogin(query: { tab?: unknown; redirect?: unknown }): boolean {
  if (query.tab === 'seller') {
    return true
  }
  return typeof query.redirect === 'string' && query.redirect.startsWith('/seller')
}

export function preferAdminLogin(query: { tab?: unknown; redirect?: unknown }): boolean {
  if (query.tab === 'admin') {
    return true
  }
  return typeof query.redirect === 'string' && query.redirect.startsWith('/admin')
}

export function decidePublicLoginKind(
  kinds: PublicLoginKind[],
  preferSeller: boolean,
  preferAdmin = false,
): LoginKindDecision {
  if (kinds.length === 1) {
    return kinds[0]
  }
  if (preferSeller && kinds.includes('seller')) {
    return 'seller'
  }
  if (preferAdmin && kinds.includes('admin')) {
    return 'admin'
  }
  return 'choose'
}

export function sellerHomePath(seller: SellerSession | null, redirect = ''): string {
  if (seller?.mustOnboard) {
    return '/seller/onboarding'
  }
  if (redirect.startsWith('/seller')) {
    return redirect
  }
  return SELLER_CENTER_PATH
}

/** 우측 상단 「관리자페이지」. 관리자면 관리 화면, 판매업체면 판매 화면. */
export function staffManagePath(input: {
  isAdmin: boolean
  isSeller: boolean
  seller: SellerSession | null
}): string | null {
  if (input.isAdmin) {
    return '/admin'
  }
  if (input.isSeller) {
    return input.seller?.mustOnboard ? '/seller/onboarding' : SELLER_CENTER_PATH
  }
  return null
}

/**
 * 판매업체·관리자 로그인 직후에는 관리 화면으로 들어가지 않는다.
 * 고객이 보던 주소가 있으면 그곳으로, 없으면 고객 홈으로 간다.
 */
export function customerPathAfterStaffLogin(redirect = ''): string {
  if (
    redirect &&
    !redirect.startsWith('/seller') &&
    !redirect.startsWith('/admin')
  ) {
    return redirect
  }
  return applyMemberHomeAfterLogin()
}

export async function identifyPublicLogin(userId: string, password: string) {
  return resolvePublicLogin({ userId, password })
}
